export enum WooCommercePaymentFieldType {
  Radio = 'radio',
  Text = 'text',
  Checkbox = 'checkbox',
  Tel = 'tel'
}
